/**
 * Adds Rivyo's aggregate rating to the native Product / ProductGroup JSON-LD that
 * `sections/product-information.liquid` outputs with the `structured_data` filter.
 * Reads `window.RivyoConfig` (snippets/clnf-rivyo-config.liquid).
 */
(function () {
  if (window.__clnfRivyoSchema) return;
  window.__clnfRivyoSchema = true;

  var PRODUCT_TYPES = { Product: true, ProductGroup: true };

  function getConfig() {
    var cfg = window.RivyoConfig || {};
    if (!cfg.proxyUrl || !cfg.shop || !cfg.product || !cfg.product.id || !cfg.product.handle) return null;
    return cfg;
  }

  function findProductSchema() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i++) {
      var parsed;
      try {
        parsed = JSON.parse(scripts[i].textContent || '');
      } catch (error) {
        continue;
      }
      var list = Array.isArray(parsed) ? parsed : [parsed];
      for (var j = 0; j < list.length; j++) {
        if (list[j] && PRODUCT_TYPES[list[j]['@type']]) {
          return { script: scripts[i], parsed: parsed, node: list[j] };
        }
      }
    }
    return null;
  }

  function fetchRating(cfg) {
    var shared = window.RivyoShared || {};
    var request;
    if (typeof shared.getProductReviews === 'function') {
      request = shared.getProductReviews(cfg, String(cfg.product.id), String(cfg.product.handle), {
        sortBy: 'recent-review',
        page: 1,
      });
    } else {
      var endpoint = new URL(cfg.proxyUrl);
      endpoint.searchParams.set('action', 'product_reviews');
      endpoint.searchParams.set('shop', cfg.shop);
      endpoint.searchParams.set('product_id', String(cfg.product.id));
      endpoint.searchParams.set('product_handle', String(cfg.product.handle));
      request = fetch(endpoint.toString()).then(function (response) {
        return response.ok ? response.json() : null;
      });
    }

    return Promise.resolve(request).then(function (payload) {
      if (!payload) return null;
      var ratingValue = Number(payload.base_rating);
      var ratingCount = Number(payload.total_review);
      if (!isFinite(ratingValue) || !isFinite(ratingCount) || ratingCount <= 0) return null;
      return {
        '@type': 'AggregateRating',
        ratingValue: Number(ratingValue.toFixed(2)),
        ratingCount: Math.round(ratingCount),
      };
    });
  }

  function init() {
    var cfg = getConfig();
    if (!cfg) return;
    fetchRating(cfg)
      .then(function (rating) {
        if (!rating) return;
        var target = findProductSchema();
        if (!target) return;
        target.node.aggregateRating = rating;
        target.script.textContent = JSON.stringify(target.parsed);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
